import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Advisor.webp";
import classroomImage from "../../Images/gov-body/meeting.webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Row } from "react-bootstrap";
import '../../Placement.css';


// const pedagogyItems = [
//     {
//         icon: "🎓",
//         title: "Expert Co-optation",
//         description:
//             "Co-opting members with specialized knowledge and experience to contribute to academic decision-making and transactions.",
//     },
//     {
//         icon: "📚",
//         title: "Promotion of Teaching & Research",
//         description:
//             "Actively fostering teaching, research, and related academic activities across the University.",
//     },
//     {
//         icon: "🧭",
//         title: "Academic Supervision",
//         description:
//             "Exercising overall supervision over the academic policies and programs of the University.",
//     },
//     {
//         icon: "🔬",
//         title: "Research Direction",
//         description:
//             "Providing direction and strategies to enhance academic standards and research methodologies.",
//     },
//     {
//         icon: "💰",
//         title: "Research Funding Proposal",
//         description:
//             "Submitting proposals to the Governing Body for the allocation of funds dedicated to research activities.",
//     },
//     {
//         icon: "🏅",
//         title: "Awards & Scholarships",
//         description:
//             "Proposing to the Governing Body the institution of fellowships, scholarships, medals, and awards, along with rules for their governance.",
//     },
//     {
//         icon: "🤝",
//         title: "Recognition of Experts",
//         description:
//             "Recognizing distinguished individuals as research guides/co-guides for interdisciplinary and multi-disciplinary subjects.",
//     },
//     {
//         icon: "🏛️",
//         title: "Organizational Schemes",
//         description:
//             "Formulating, modifying, and revising schemes for faculties, schools, and departments, subject to Governing Body approval.",
//     },
// ];

const body = [
    {
        name: "Mr. Jitendra Nahar",
        designation: "Founder Trustee",
        remarks: "Kruti Institute of Technology and Engineering, Raipur"
    },
    {
        name: "Dr. Rajan Chopra",
        designation: "Chancellor",
        remarks: "Mahatma Gandhi University, Meghalaya"
    },
    {
        name: "Dr. A.L Agrawal",
        designation: "President - World Education Mission",
        remarks: "Chairman, Arunachal University of Studies"
    },
    {
        name: "Mr. Sameep Shastri",
        designation: "Vice Chairman",
        remarks: "BRICS CCI, Indian Institute of Governance & Leadership"
    },
    {
        name: "Dr. Munir Sayyad",
        designation: "General Manager",
        remarks: "Head of Reliance JIO Quality Assurance Lab, Mumbai"
    },
    {
        name: "Adv. Syed Zeeshan",
        designation: "Counsel",
        remarks: "Advocate, Chhattisgarh, India"
    },
    {
        name: "Dr. Akhilesh Kumar Bhatt",
        designation: "Dy Director of Education",
        remarks: "GNCT – Delhi"
    },
    {
        name: "Adv. D.G. Naik",
        designation: "Senior Counsel",
        remarks: "High Court, Mumbai"
    },
    {
        name: "Mr. Shakti Swamy",
        designation: "Consultant and Coach",
        remarks: "Bigvacancy.com"
    },
    {
        name: "Adv. SK Farhan",
        designation: "Senior Counsel",
        remarks: "District Court, Raipur"
    },
    {
        name: "Dr. Ravish Singh",
        designation: "Director",
        remarks: "Thakur R Ramnarayan College of Arts & Commerce"
    },
    {
        name: "Mr. Anil Mittal",
        designation: "Executive Vice President",
        remarks: "Jindal Steel and Power Ltd"
    },
    {
        name: "Mr. Pradeep Tandon",
        designation: "President",
        remarks: "Jindal Steel and Power Ltd"
    },
    {
        name: "Mr. Sanjay Gupta",
        designation: "Chief Human Resource Officer",
        remarks: "Hira Group"
    },
    {
        name: "Mr. Rabindra Shah",
        designation: "Chief Technology Officer",
        remarks: "Indian Register of Shipping"
    },
    {
        name: "Mr. Ragish Rohatgi",
        designation: "GM HR and Admin",
        remarks: "D B Power Limited"
    },
    {
        name: "Mr. Dilip Kumar Mohanty",
        designation: "President - HRM",
        remarks: "Jayaswal Neco Industries Limited"
    },
    {
        name: "Mr. NV Sanjeev",
        designation: "Managing Director",
        remarks: "Accenture"
    },
    {
        name: "Mr. Rishi Upmanyu",
        designation: "Senior Vice President",
        remarks: "T-Mobile"
    },
    {
        name: "Mr. Babuji Abraham",
        designation: "Founder and Chief Technology Officer",
        remarks: "V Rize Technologies"
    },
    {
        name: "Mr. Deepak Likhmania",
        designation: "Managing Director",
        remarks: "Interviz Consulting"
    },
    {
        name: "Mr. Rahul Mishra",
        designation: "Managing Director",
        remarks: "Cialfor Labs Pvt Ltd, Pune"
    },
    {
        name: "Mr. Sumeet Malik",
        designation: "Founder",
        remarks: "PEPCoding"
    },
    {
        name: "Mr. Lakshman Gupta",
        designation: "Director - Operations",
        remarks: "DiracERP Solutions Pvt Limited"
    },
    {
        name: "Mr. Sandeep Gupta",
        designation: "Regional Head",
        remarks: "Tata Consultancy Services"
    },
    {
        name: "Mr. Somesh Sharma",
        designation: "COO & Founder",
        remarks: "Augtech NextWealth IT Services Pvt Ltd"
    },
    {
        name: "Mr. Rakesh Kumar Singh",
        designation: "Chief Human Resource Officer",
        remarks: "PNC Infratech Limited"
    },
    {
        name: "Mr. Anil Soni",
        designation: "Chief Human Resource Officer",
        remarks: "Ind Synergy Limited"
    },
    {
        name: "Mr. D P Singh",
        designation: "Senior Vice President",
        remarks: "CITI Corp"
    },
    {
        name: "Mr. Rajeev Singh",
        designation: "Vice President",
        remarks: "US Bank"
    },
    {
        name: "Mr. Meghal Agrawal",
        designation: "CEO and Founder",
        remarks: "Code Nicely"
    },
    {
        name: "Mr. G Swamy",
        designation: "President",
        remarks: "Andhra Association"
    }
];

const BoardAdvisors = () => {
    return (
        <>
            <title>Board of Advisors – ISBM University | Expert Guidance & Vision</title>
            <meta
                name="description"
                content="Explore ISBM University's Board of Advisors, a team of industry leaders and academicians providing strategic insights for academic excellence."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Our Esteemed Board of Advisors</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Board of Advisors
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Board of Advisors</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                Board of Advisors – Steering Visionaries at ISBM University
                                The ISBM University Board of Advisors is a who's who of academic thought leaders,
                                industry veterans, entrepreneurs, and policymakers who provide valuable inputs and
                                strategic insights to the university. Their combined experience is instrumental in
                                helping shape our academic policies, making curriculum match industry needs,
                                and fortifying our vision for future-proof education.
                            </p>
                            <p className="text-muted">
                                Our advisors proactively work towards improving the quality of teaching,
                                research, and corporate interaction. With extensive experience in fields such as technology,
                                business, education, law, and public service, they keep ISBM University updated with
                                international trends and national applicability. Their guidance enables us to develop innovation,
                                inclusivity, and excellence in each program offered by us.
                            </p>
                            <p className="text-muted">
                                The Board's active involvement will ensure that our learners not only become academically
                                competent but also job-ready. Their insights drive strategic alliances, international collaborations,
                                and thought leadership—positioning ISBM University as a hub of excellence in higher learning
                                and career advancement.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper">
                                <img class="rounded-4 shadow-lg" src={classroomImage} alt="Business Professionals Having a Meeting in a Conference Room" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            {/* <section className="container-xxl ptb-50">
                <h2 className="text-center fw-bold">Powers and functions of the Academic Council</h2>
                <div className="underline-center mb-5"></div>
                <div className="row m-0">
                    {pedagogyItems.map((item, index) => (
                        <div className="col-md-6 col-lg-4 mb-4" key={index}>
                            <div className="d-flex h-100 border-end pe-3">
                                <div className="me-3 fs-1 text-secondary">{item.icon}</div>
                                <div>
                                    <h6 className="fw-bold mb-2 text-dark">{item.title}</h6>
                                    <p className="text-muted small mb-0">{item.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Member of the Board of Advisors</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation-light text-black fw-bold ms-2 ">{member.designation}</span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* <section className="meeting">
                <div className="edu_letter_main_wrapper container-xxl">
                    <div className="container-xxl">
                        <div className="row p-4 ">
                            <div className="col-md-6">
                                <h3 className="text-white fw-bold m-0">
                                    MOM of Academic Council meeting
                                </h3>
                            </div>

                            <div className="col-md-6 text-md-end text-center">
                                <div className="d-flex flex-column align-items-md-end gap-3">
                                    <a
                                        href="/static/media/MOM%20of%20AC%20meeting%2025112022.11a11865a0b5c66e6722.pdf"
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn download border fw-bold px-5 p-2"
                                    >
                                        Download MOM
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <Footer />
        </>
    );
};

export default BoardAdvisors;
